import script from "./AddCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomer.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomer.vue?vue&type=style&index=0&id=ae372142&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae372142"]])

export default __exports__